<template>
  <div class="main">
    <el-container class="home-container"
                  direction='vertical'>
      <router-view></router-view>
      <!-- <div class="coryright">
        Copyright 2012-2016 V货帮物流管理平台 - Powered&nbsp;By&nbsp;jushihui&nbsp;V3.0.1
      </div> -->
    </el-container>
  </div>
</template>
<script>
export default {
  name: 'logistics',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus">
.main
  // position absolute
  // top 0px
  // left 0px
  // right 0px
  // bottom 0px
  .home-container
    position absolute
    top 0
    left 0
    right 0
    bottom 0px
    overflow hidden
    background #F7F9FB
    .coryright
      position absolute
      text-align center
      font-size 12px
      left 0
      line-height 30px
      right 0px
      bottom 0
      color #606266
      // background #F7F9FB
      background #f66
  .el-aside
    background #fff
    box-shadow 2px 2px 10px #e6fefe
    z-index 100
  .el-main
    padding 0
    background #f7f9fb
</style>
